
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentcolor","d":"M7.707 9.256a.999.999 0 11-1.414 1.414.999.999 0 111.414-1.414zm13.852 6.085l-.565.565a4.977 4.977 0 01-1.435 3.399l-3.167 3.208A4.965 4.965 0 0112.849 24h-.017c-1.335 0-2.59-.52-3.534-1.464l-7.416-7.353a2.987 2.987 0 01-.864-2.453l.765-6.916a1 1 0 01.858-.881l6.889-.942a3.018 3.018 0 012.528.851l7.475 7.412c.387.387.697.823.931 1.288a3.01 3.01 0 00-.342-3.835l-7.591-7.405a1.009 1.009 0 00-.851-.292l-6.889.942a1.001 1.001 0 01-1.127-.855A1.001 1.001 0 014.519.971l6.89-.943a3 3 0 012.528.852l7.589 7.405c1.946 1.945 1.957 5.107.032 7.057zm-3.438-1.67l-7.475-7.412a1.016 1.016 0 00-.847-.287l-6.115.837-.679 6.14a.994.994 0 00.287.816l7.416 7.353c.569.57 1.322.881 2.123.881h.01a2.972 2.972 0 002.126-.893l3.167-3.208a3.006 3.006 0 00-.014-4.229z"}})])
          )
        }
      }
    